import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const Svg = styled("svg")(({ theme }) => ({
  width: 18,
  height: 18,
  fill: theme.palette.text.primary,
  "&:hover path": {
    fill: theme.palette.primary.main,
  },
}));

const ChartIcon = (): JSX.Element => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Svg
        className="chart-icon"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.33342 1.50033C2.33342 1.04009 1.96032 0.666992 1.50009 0.666992C1.03985 0.666992 0.666752 1.04009 0.666752 1.50033L0.66675 15.1936C0.666725 15.4039 0.666701 15.6087 0.680873 15.7822C0.696437 15.9727 0.73316 16.1975 0.848408 16.4236C1.0082 16.7372 1.26316 16.9922 1.57677 17.152C1.80295 17.2673 2.02773 17.304 2.21823 17.3195C2.3917 17.3337 2.59653 17.3337 2.80685 17.3337L16.5001 17.3337C16.9603 17.3337 17.3334 16.9606 17.3334 16.5003C17.3334 16.0401 16.9603 15.667 16.5001 15.667H2.83342C2.58631 15.667 2.4511 15.6663 2.35395 15.6584L2.34296 15.6574L2.34201 15.6465C2.33407 15.5493 2.33342 15.4141 2.33342 15.167V1.50033Z" />
        <path d="M16.2749 6.23676C16.5895 5.90091 16.5724 5.37355 16.2365 5.05888C15.9007 4.7442 15.3733 4.76137 15.0586 5.09723L11.8793 8.49062L9.27687 7.13936C9.27148 7.13656 9.26557 7.13343 9.25916 7.13002C9.25492 7.12776 9.25045 7.12538 9.24578 7.12288C9.13433 7.06335 8.90285 6.93971 8.6449 6.91647C8.42841 6.89696 8.21058 6.93425 8.0129 7.02464C7.77736 7.13235 7.60017 7.32593 7.51486 7.41914C7.5124 7.42183 7.51002 7.42444 7.50771 7.42696C7.5016 7.43362 7.49603 7.43967 7.49102 7.44501L4.2253 10.9306C3.91062 11.2664 3.92779 11.7938 4.26365 12.1084C4.59951 12.4231 5.12686 12.406 5.44154 12.0701L8.62092 8.67671L11.2233 10.028C11.2323 10.0326 11.2427 10.0382 11.2544 10.0444C11.3658 10.104 11.5973 10.2276 11.8553 10.2509C12.0718 10.2704 12.2896 10.2331 12.4873 10.1427C12.7228 10.035 12.9 9.84139 12.9853 9.74818C12.9943 9.7384 13.0023 9.72966 13.0091 9.72231L16.2749 6.23676Z" />
      </Svg>
    </Box>
  );
};

export default ChartIcon;
